<template>
  <v-container>
    <v-row justify="center">
      <v-col md="6" sm="7" xs="12">
        <v-card>
          <v-form ref="form">
            <v-row align="center" justify="space-between" no-gutters>
                <v-card-title>
                  Password Reset
                </v-card-title>
            </v-row>
            <v-row align="center" justify="center" no-gutters>
              <v-card-text>
                <h3>Please enter your email and a reset link will be sent to your account.</h3>
              </v-card-text>
            </v-row>
            <v-card-text>
              <v-text-field
                v-model="userEmail"
                data-cy="password-reset-email"
                :rules="[rules.required]"
                label="Email"
              />
            </v-card-text>
            <v-card-actions>
              <v-row justify="center">
                <v-col cols="auto">
                  <v-btn
                    data-cy="login-btn-submit"
                    color="primary"
                    @click="submit"
                  >
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getUserByEmail, sendResetPassword } from '../services/users';

export default {
  data() {
    return {
      resetData: {
      },
      userEmail: '',
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        },
      },
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        // need to get a user to pass to the password reset function
        console.log('getting in here');
        let user = await getUserByEmail(this.userEmail);
        user = user['data'];
        console.log(user);

        // Sends the email to the user
        sendResetPassword(user);
        this.$router.push({ name: 'password-reset' });
      }
      catch(err){
        this.$emit('snackbar', { text: 'Unable to send a reset link to this email.', color: 'red' });
        return;
      }
    },
  },
};
</script>

<style>
  .forgot {
    margin: 10px;
  }
</style>
